import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

/**
 * MIT License
 * Copyright (c) React Training 2015-2019 Copyright (c) Remix Software 2020-2022
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
 * documentation files (the "Software"), to deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to the following conditions:
 */
const useMatch = pattern => {
  const { pathname } = useLocation();
  return useMemo(() => matchPath(pathname, pattern), [pathname, pattern]);
};

export default useMatch;
